import { Component } from '@angular/core';

@Component({
  selector: 'sm-new-reminder',
  templateUrl: './new-reminder.component.html',
  styleUrls: ['./new-reminder.component.scss']
})
export class NewReminderComponent {

}
